import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoButton } from 'components/no-auth/common/promo-button/PromoButton';
import { RichText } from 'components/no-auth/common/promo-dangerously-html/RichText';
import { PromoRow } from 'components/no-auth/common/PromoRow/PromoRow';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { TextComponent } from 'components/no-auth/common/sections/styles';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { EMAIL_BUSINESS_CONNECT, EMAIL_GLOBAL_ACCOUNT, EMAIL_SUPPORT } from 'constants/UrlConstants';

import { usePageMessages } from 'hooks/selectors';

const HelpArticlePage = (props) => {
    const { helpContactUS } = usePageMessages();
    const showContactUs = props.renderOptions?.isGlobalAccount || props.linkMailToSupport || props.renderOptions?.isBusinessConnect;

    const getLink = (props) => {
        if (props.renderOptions?.isGlobalAccount) {
            return <PromoButton variant="primary" type="link" href={EMAIL_GLOBAL_ACCOUNT} caption={helpContactUS} />;
        }

        if (props.linkMailToSupport) {
            return <PromoButton variant="primary" type="link" href={EMAIL_SUPPORT} caption={helpContactUS} />;
        }

        if (props.renderOptions?.isBusinessConnect) {
            return <PromoButton variant="primary" type="link" href={EMAIL_BUSINESS_CONNECT} caption={helpContactUS} />;
        }
    };

    return (
        <>
            <ColoredSectionContainer dimension="average">
                <PromoRow indent="adaptive-32-48-64">
                    <HeadingSection title={props.helpSectionName} dataTestId="help-article-h1-title" />
                    <TextComponent>
                        <RichText tag="div" dangerouslyHtml={props.helpSectionText} dataTestId="help-article-div-text" color="gray80" />
                    </TextComponent>
                </PromoRow>
            </ColoredSectionContainer>
            {showContactUs && (
                <ColoredSectionContainer dimension="average">
                    <PromoRow textAlign="right" indent="adaptive-32-48-64">
                        {getLink(props)}
                    </PromoRow>
                </ColoredSectionContainer>
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        helpSectionName: state.messages?.pageMessages?.helpSectionName,
        helpSectionText: state.messages?.pageMessages?.helpSectionText,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(HelpArticlePage));
